import { Injectable } from '@angular/core';
import { ParametroHttpService } from 'app/main/parametro/parametro-http.service';
import { Parametro } from './../interfaces/parametro';
import { SessionStorageService } from './session-storage.service';
import { getTipoSistemaKey, TipoSistemaKey } from '../interfaces/enum/tipo-sistema';
import { Observable, shareReplay, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParametroUtilsService {
  private tipoSistemaSubject = new Subject<TipoSistemaKey[]>();
  private tipoSistema: TipoSistemaKey[];
  private parametrosPorNome = new Map<string, Observable<Parametro>>();

  constructor(
    private _parametroHttpService: ParametroHttpService,
    private _sessionStorageService: SessionStorageService,
  ) {
    this.carregaTipoSistema();
  }

  private carregaTipoSistema() {
    const parametro = this.getParametroByNome('PARAM_TIPO_SISTEMA');
    this.tipoSistema = this.getTipoSistemaKeysFromParametro(parametro?.valor);

    this.tipoSistemaSubject.subscribe((tipoSistema) => {
      this.tipoSistema = tipoSistema;
    });
  }

  getParametroByNome(nome: String): Parametro {
    try {
      const parametrosJson = this._sessionStorageService.getItem("parametros");
      
      if (!parametrosJson) {
        return null;
      }
      
      const parametros: Parametro[] = JSON.parse(parametrosJson);
      const index = parametros.findIndex(p => p.nome === nome);
      if (index >= 0) {
        return parametros[index];
      }
      return null;
    } catch (error) {
      console.error('Erro ao buscar parâmetro:', error);
      return null;
    }
  }

  getParametroByNomeCarregado(nome: string): Observable<Parametro> {
    if (!this.parametrosPorNome.has(nome)) {
      this.parametrosPorNome.set(nome, this._parametroHttpService.getParametroByName(nome).pipe(shareReplay(1)));
    }

    return this.parametrosPorNome.get(nome);
  }

  refreshParametros() {
    this._parametroHttpService.getParametros().subscribe({
      next: (result => {
        this._sessionStorageService.setItem("parametros", JSON.stringify(result))

        const parametro = this.getParametroByNome('PARAM_TIPO_SISTEMA');
        this.tipoSistemaSubject.next(this.getTipoSistemaKeysFromParametro(parametro?.valor));
      }),
      error: (error => {
        console.log(error);
      })
    })
  }

  private getTipoSistemaKeysFromParametro(valor: any): TipoSistemaKey[] {
    if (!valor) {
      return [];
    }

    const valores = Array.isArray(valor) ? valor : [valor];

    return valores
      .map(item => getTipoSistemaKey(item))
      .filter((tipoSistemaKey): tipoSistemaKey is TipoSistemaKey => !!tipoSistemaKey);
  }

  get getTipoSistema() {
    return this.tipoSistema;
  }

  get temSistemaAgenciamento() {
    return this.getTipoSistema?.includes('AGENCIAMENTO_CARGA') ?? false;
  }

  get temSistemaRodoviario() {
    return this.getTipoSistema?.includes('TRANSPORTE_RODOVIARIO') ?? false;
  }

  get isSomenteRodoviario() {
    return this.temSistemaRodoviario && !this.temSistemaAgenciamento;
  }
}
